<template>
  <!-- :title="action=='add'?'添加子菜单':'编辑子菜单'"-->
  <basic-dialog
    :visible="visible"
    :title="addOrEdit"
    :width="720"
    :update-vis="updateVis"
    :handle-close="handleClose"
    :handle-closed="handleClosed"
    :handle-ok="handleOk"
    :okText="this.action == 'add' ? $t('language.5o6vkto5xjo0') : $t('language.5o6u3frcn9k0')"
  >
    <el-form
      ref="form"
      size="small"
      label-position="right"
      label-width="128px"
      :model="dto"
      :rules="rules"
      @submit.native.prevent
    >
      <div class="entity-dlg__block">
        <div class="entity-dlg__block-bd">
          <el-row :gutter="24">
            <el-col :span="20">
              <el-form-item :label="$t('language.5o6up3960k80')" prop="resourceCode">
                <el-input
                  :disabled="action == 'edit'"
                  v-model.trim="dto.resourceCode"
                  :placeholder="$t('language.5o6uhukiuhl0')"
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :span="20">
              <el-form-item :label="$t('language.5o6up3960fo0')" prop="resourceName">
                <el-input v-model.trim="dto.resourceName" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row v-if="action == 'edit'" :gutter="24">
            <el-col :span="20">
              <el-form-item :label="$t('language.5o6v4bolg4w0')" prop="resourceSeq">
                <el-input-number
                  v-model="dto.resourceSeq"
                  :min="1"
                  :max="10000"
                  :step-strictly="true"
                  :precision="0"
                ></el-input-number>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :span="20">
              <el-form-item :label="$t('language.5o6otz4p1n40')" prop="resourceType">
                <el-select
                  clearable
                  filterable
                  v-model="dto.resourceType"
                  placeholder=""
                >
                  <el-option
                    v-for="(item, key) of resourceTypeList"
                    :key="key"
                    :label="item"
                    :value="+key"
                  />
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :span="20">
              <el-form-item label="URL" prop="resourceUrl">
                <el-input v-model="dto.resourceUrl" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :span="20">
              <el-form-item label="Icon" prop="icon">
                <el-input v-model="dto.icon" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24" v-if="safetySwitch">
            <el-col :span="20">
              <el-form-item :title="$t('language.5o6v4bolf5k0')" :label="$t('language.5o6v4bolf5k0')" prop="sensitiveMark">
                <el-select
                  clearable
                  filterable
                  v-model="dto.sensitiveMark"
                  placeholder=""
                >
                  <el-option
                    v-for="(item, key) of sensitiveMarkList"
                    :key="key"
                    :label="item"
                    :value="+key"
                  />
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row
            :gutter="24"
            v-if="safetySwitch && this.dto.sensitiveMark === 1"
          >
            <el-col :span="20">
              <el-form-item :label="$t('language.5o6uhukipfl0')" prop="sensitiveType">
                <el-select
                  clearable
                  filterable
                  v-model="dto.sensitiveType"
                  placeholder=""
                >
                  <el-option
                    v-for="(item, key) of sensitiveTypeList"
                    :key="key"
                    :label="item"
                    :value="+key"
                  />
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="24" v-if="safetySwitch">
            <el-col :span="20">
              <el-form-item :label="$t('language.5o6v4bolgz40')" prop="highRiskType">
                <el-select
                  clearable
                  filterable
                  v-model="dto.highRiskType"
                  placeholder=""
                >
                  <el-option
                    v-for="(item, key) of highRiskTypeList"
                    :key="key"
                    :label="item"
                    :value="+key"
                  />
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row
            :gutter="24"
            v-if="this.$store.state.menuResource.appSource === 'LCP'"
          >
            <el-col :span="20">
              <el-form-item :label="$t('language.5o6uhukipal0')" prop="extendedField">
                <el-input
                  clearable
                  v-model="dto.extendedField"
                  type="textarea"
                  :rows="3"
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row
            :gutter="24"
            v-for="(item, index) of extendFields"
            :key="index"
          >
            <el-col :span="20">
              <el-form-item
                :label="item.name"
                :prop="item.key"
                :rules="item.rules"
              >
                <el-input
                  v-if="item.type === 'input'"
                  v-model.trim="dto[item.key]"
                  :placeholder="item.placeholder"
                  clearable
                />
                <el-select
                  v-else-if="item.type === 'select'"
                  v-model.trim="dto[item.key]"
                  :placeholder="item.placeholder"
                  clearable
                  filterable
                >
                  <el-option
                    v-for="subItem of item.options"
                    :key="subItem.code"
                    :label="subItem.label"
                    :value="subItem.value"
                  />
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :span="20">
              <el-form-item :label="$t('language.5o6otz4p1w00')" prop="remark">
                <el-input
                  clearable
                  v-model="dto.remark"
                  type="input"
                  :rows="3"
                  maxlength="121"
                />
              </el-form-item>
            </el-col>
          </el-row>
        </div>
      </div>
    </el-form>
  </basic-dialog>
</template>

<script>
import EntityDialog from "@/mixins/entityDialog";

export default {
  mixins: [EntityDialog],
  props: {
    queryObj: Object,
    tenementInfoObj: Object,
    level: Number,
    parentId: Number,
  },
  data() {
    return {
      rules: {
        resourceName: [
          { required: true, message: this.$t('language.5o6v4bolg1w0'), trigger: "blur" },
          // { pattern: CNST.REG_EXP.NORMAL, message: "菜单名称不可输入特殊字符" },
          { max: 50, message: this.$t('language.5o6uhukipai0') },
        ],
        resourceCode: [
          { required: true, message: this.$t('language.5o6v4bolgz70'), trigger: "blur" },
          {
            pattern: CNST.REG_EXP.NORMAL_RESOURCE,
            message: this.$t('language.5o6phukipal0'),
          },
          { max: 50, message: this.$t('language.5o6uhupipal0') },
          // {
          //   pattern: /^[a-zA-Z0-9_.\/-]{1,50}$/,
          //   // maxLength: 50, // 这个没有生效
          //   message: "50个字符(字母、数字、下划线、中划线、“.”、“/”)",
          // },
          {
            validator: (rule, value, callback) => {
              if (this.action == "add") {
                api.menuResource
                  .exist({
                    data: {
                      appCode: this.queryObj.appCode,
                      resourceCode: this.dto.resourceCode,
                      tenementCode: this.tenementInfoObj.tenementCode,
                      //  resourceName: this.dto.resourceName
                    },
                  })
                  .then((res) => {
                    if (res && res.code == "200") {
                      if (res.data) {
                        return callback(
                          new Error(this.$t('language.5oouhukipal0'))
                        );
                      } else {
                        return callback();
                      }
                    } else if (res.code == "300") {
                      return;
                    } else if (res) {
                      // console.log('接口报错码', res.code)
                      this.$message.error(
                        res.msg || res.errorCode || this.$t('language.5o6vkto5zmk0')
                      );
                      return false;
                    }
                  });
              } else {
                callback();
              }
            },
            trigger: "blur",
          },
        ],
        resourceType: [
          { required: true, message: this.$t('language.5o6v4bolg2w0'), trigger: "change" },
        ],
        sensitiveMark: [
          { required: true, message: this.$t('language.5o6v4bolg3w0'), trigger: "change" },
        ],
        highRiskType: [{ required: false }],
        resourceUrl: [
          { max: 400, message: this.$t('language.5oouhukiwal0'), trigger: "change" },
          { pattern: CNST.REG_EXP.URLPLUS, message: this.$t('language.5oouhubipal0') },
        ],
        icon: [
          { max: 400, message: this.$t('language.5oouhuki4al0'), trigger: "change" },
        ],
        resourceSeq: [
          { required: true, message: this.$t('language.5uouhuki4al0'), trigger: "blur" },
          {
            validator: (rule, value, callback) => {
              let data = {};
              console.log("父节点" + this.$store.state.menuResource.parentId);

              if (this.action == "add") {
                data = {
                  appCode: this.queryObj.appCode,
                  resourceSeq: this.dto.resourceSeq,
                  tenementCode: this.tenementInfoObj.tenementCode,
                  level: this.level,
                  resourceCode: this.dto.resourceCode,
                  parentId: this.$store.state.menuResource.parentId,
                };
              } else {
                data = {
                  appCode: this.queryObj.appCode,
                  resourceSeq: this.dto.resourceSeq,
                  id: this.dto.id,
                  tenementCode: this.tenementInfoObj.tenementCode,
                  level: this.dto.level,
                  resourceCode: this.dto.resourceCode,
                  parentId: this.$store.state.menuResource.parentId,
                };
              }
              api.menuResource
                .seqExist({
                  data,
                })
                .then((res) => {
                  if (res && res.code == "200") {
                    if (res.data) {
                      return callback(new Error(this.$t('language.5oouhuki4au0')));
                    } else {
                      return callback();
                    }
                  } else {
                    this.$message.error(
                      (res && res.msg) || res.errorCode || this.$t('language.5o6vkto5zmk0')
                    );
                  }
                });
            },
            trigger: "blur",
          },
        ],
        remark: [
          { max: 120, message: this.$t('language.5o6vg67fntc0') },
        ],
      },
      resourceTypeList: CNST.ENUMS.resourceType,
      addOrEdit: null,
      safetySwitch: null,
      sensitiveMarkList: CNST.ENUMS.yesOrNo,
      highRiskTypeList: CNST.ENUMS.highRiskType,
      sensitiveTypeList: CNST.ENUMS.sensitiveType,
    };
  },
  created() {
    //上两行必传 level字段后非必传
    this.allFields = [
      "resourceName",
      "resourceCode",
      "resourceType",
      "resourceUrl",
      "icon",
      "resourceSeq",
      { key: "appCode", default: 1 },
      { key: "appId", default: 1 },
      { key: "level", default: 1 },
      { key: "tenementId", default: this.tenementInfoObj.id },
      { key: "tenementCode", default: this.tenementInfoObj.tenementCode },
      "parentId",
      { key: "resourceSource", default: "in" },
      "remark",
      "id",
    ];
    (this.disFieldKeys = []), (this.addOrEdit = this.buttonData("tjzcd").name);
  },
  methods: {
    handleClose() {
      this.updateVis(false);
      this.$refs["form"].resetFields();
      this.dto = {
        extendedField: undefined,
        resourceName: undefined,
        resourceCode: undefined,
        resourceType: undefined,
        resourceSeq: undefined,
        resourceUrl: undefined,
        icon: undefined,
        remark: undefined,
      };
    },
    toEnd() {
      //重新整理 修改入参  10.17
      if (this.action === "add") {
        this.dto = Object.assign(
          {},
          this.dto,
          { appCode: this.queryObj.appCode },
          { appId: this.queryObj.appId },
          { tenementId: this.tenementInfoObj.id },
          { tenementCode: this.tenementInfoObj.tenementCode },
          { level: 1 },
          { parentId: undefined },
        );
      }
      return this.dto;
    },
    async queryExtendField() {
      this.extendFields = [];
      this.extendFieldKeys = [];
      const params = { data: { tenementCode: this.tenementCode ,appCode:this.queryObj.appCode} };
      const { code, data } = await api.menuResource.queryExtendField(params);
      if (code === 200) {
        this.handleSetExtendFields(data || []);
      }
    },
    querySafetySwitch() {
      api.apps
        .querySafetySwitch({
          tenementCode: this.tenementCode,
          appCode: this.queryObj.appCode,
        })
        .then((res) => {
          if (res && res.code === 200 && res.data != null) {
            this.safetySwitch = res.data;
          }
        });
    },
  },
  watch: {
    visible(vis) {
      if (vis) {
        this.queryExtendField();
        this.querySafetySwitch();
      }
      if (this.action == "add") {
        this.addOrEdit = this.buttonData("tjzcd").name;
      } else {
        this.addOrEdit = this.buttonData("bjcdzy").name;
      }
    },
  },
};
</script>
